import { MeteringType } from '@enums';
import { DisruptionInfo } from './disruptionInfo.model';
import { MeteringPointFunctionControl } from './metering-point-function-control';
import { MeteringPointFunctionControlContract, MeteringPointReadingPoint } from '@model';
import { MeteringPointIntelligyStatus } from './meteringpoint-intelligy-status.model';

export class MeteringPoint {
  id?: number;
  name?: string;
  type?: string;
  meteringType?: MeteringType;
  area?: number;
  categoryId?: string;
  category?: string;
  addresses?: MeteringPointAddress[];
  customerId?: string;
  customerName?: string;
  containedMeteringPoints?: MeteringPoint[];
  disruptionInfos?: DisruptionInfo[];
  hasFunctionControl?: boolean;

  functionControls?: MeteringPointFunctionControl[];
  functionControlsLoaded?: boolean;
  functionControlsLoading?: boolean;

  functionControlContract?: MeteringPointFunctionControlContract;
  functionControlContractLoaded?: boolean;
  functionControlContractLoading?: boolean;

  readings?: MeteringPointReadingPoint[];
  readingsLoaded?: boolean;
  readingsLoading?: boolean;
  
  contractId?: number;
  standardProduct?: string;
  connectedAtDate?: string;
  latestConstructionDate?: string;
  hasIntelligy?: boolean;

  selected?: boolean;
  added?: boolean;
  parentGroups?: { name: string; id: number }[];
  addressLabel?: string;
  intelligyStatus?: MeteringPointIntelligyStatus;

  // External Organisation
  isWhiteLabel?: boolean;
  externalOrganisationId?: number;
  externalOrganisationAlias?: string;


  static MockOne(id = 1, name = 'a', customerId = '1') {
    return { id, name, customerId, addresses: [MeteringPointAddress.MockOne(id)] } as MeteringPoint;
  }

  static MockMany() {
    return [MeteringPoint.MockOne(1), MeteringPoint.MockOne(2), MeteringPoint.MockOne(3)];
  }
}

export class MeteringPointAddress {
  type?: string;
  street?: string;
  streetNo?: number;
  zip?: number;
  city?: string;
  box?: number;
  coAddress?: string;
  country?: string;

  static MockOne(streetNo = 1, street = 'a') {
    return { streetNo: streetNo, street } as MeteringPointAddress;
  }

  static MockMany() {
    return [MeteringPointAddress.MockOne(1), MeteringPointAddress.MockOne(2)];
  }
}
